export default __webpack_public_path__ + "static/media/price-bg.a33131a2.png";